export default "/images/c3e8a13e928abe715d792a7d9142f8e5.avif";